import { createRouter, createWebHistory } from 'vue-router'
import frontendRoutes from './frontend'
import userRoutes from './user'
import vendorRoutes from './vendor'
import { isAuthenticated } from '@/services/auth'

const routes = [
    ...frontendRoutes,
    ...userRoutes,
    ...vendorRoutes,
    { path: '/:pathMatch(.*)*', name: 'NotFound', component: () => import('@/views/frontend/NotFound.vue') }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !isAuthenticated()) {
    next({ name: 'login', query: { redirect: to.fullPath } })
    return
  }
  next()
})

export default router
